<template>
  <v-card>
    <v-card-title>
      <v-icon large right>fas fa-user-clock</v-icon>
      Total hours by Lumper
      <v-spacer></v-spacer>
      <v-text-field
        v-model="search"
        append-icon="mdi-magnify"
        label="Search"
        single-line
        hide-details
      ></v-text-field>
    </v-card-title>
    <v-card-title>  
      <v-row wrap>    
        <v-col cols="12" sm="6" md="4">
            <v-menu v-model="menu1" :close-on-content-click="false" :nudge-right="40" transition="scale-transition" offset-y min-width="290px" >
                <template v-slot:activator="{ on }">
                    <v-text-field  v-model="dateStart" label="Start date" prepend-icon="event" readonly v-on="on" ></v-text-field>
                </template>
                <v-date-picker color="blue darken-3" v-model="dateStart" @input="menu1 = false"></v-date-picker>
            </v-menu>
        </v-col>
        <v-col cols="12" sm="6" md="4">
            <v-menu  v-model="menu2" :close-on-content-click="false" :nudge-right="40" transition="scale-transition" offset-y min-width="290px" >
                <template v-slot:activator="{ on }">
                    <v-text-field  v-model="dateEnd" label="End date" prepend-icon="event" readonly v-on="on" ></v-text-field>
                </template>
                <v-date-picker   color="blue darken-3" v-model="dateEnd" @input="menu2 = false"></v-date-picker>
            </v-menu>
        </v-col>
        <v-col cols="12" sm="6" md="4">
            <v-btn @click="getAll()" class="ma-1" tile outlined color="blue darken-3" v-if="dateStart != '' && dateEnd != ''">
                <v-icon left>fas fa-search</v-icon>
            </v-btn>
            <v-btn @click="resetFilter()" class="ma-1" tile outlined color="blue darken-3" >
                <v-icon left>fas fa-eraser</v-icon>
            </v-btn>
        </v-col>
      </v-row>
    </v-card-title>
        <v-data-table
        :headers="headers"
        :items="desserts"
        :search="search"
        :single-expand="singleExpand"
        :expanded.sync="expanded"
        item-key="userId"
        show-expand
        class="elevation-1"
      >
        <template v-slot:no-data v-if="desserts.length === 0">
            <v-progress-linear indeterminate color="blue darken-3" v-if="waiting"></v-progress-linear>
            <v-alert outlined class="text-xs-center" :value="true" type="warning" v-if="!waiting">No Data</v-alert>
        </template>
        <template v-slot:item.totalPaymed="{ item }">
            $ {{ item.totalPaymed }}
        </template>
        <template v-slot:item.totalByPaymed="{ item }">
            $ {{ item.totalByPaymed }}
        </template>
        <template v-slot:top>
          <v-toolbar flat>
            <v-spacer></v-spacer>
            <v-switch
              v-model="singleExpand"
              label="Single expand"
              class="mt-2"
            ></v-switch>
          </v-toolbar>
        </template>
            <template v-slot:expanded-item="{ headers, item }">
              <td :colspan="headers.length">
                <v-card>
                  <div class="deep-purple lighten-4 text-center">
                    <span >Detail</span>
                  </div>
                  <template>
                    <v-data-table dense :headers="headersDetail" :items="item.travelWorkers" item-key="idTravelWorker" class="elevation-1">
                        <template v-slot:item.totalPaymed="{ item }">
                            $ {{ item.totalPaymed }}
                        </template>
                        <template v-slot:item.datePaymed="{ item }">
                         <p v-if="item.paymed === true"> {{ item.datePaymed }} </p>
                      </template>
                      <template v-slot:item.paymed="{ item }">
                        <v-chip  :color="getColor(item.paymed)" >
                          {{ item.paymed }}
                        </v-chip>
                      </template>
                      <template v-slot:item.actions="{ item }">
                        <v-tooltip left color="#d69b01">
                            <template v-slot:activator="{ on }">
                                <v-btn small class="ml-2" icon color="#d69b01" v-on="on" @click="payWorker(item)">
                                    <v-icon small>far fa-money-bill-alt</v-icon>
                                </v-btn>                        
                            </template>
                            <span class="fontButton">Pay</span>
                        </v-tooltip> 
                      </template>
                    </v-data-table>
                  </template>
            </v-card>
          </td>
        </template>
        <template v-slot:item.actions="{ item }">
            <v-tooltip bottom color="blue">
                <template v-slot:activator="{ on }">
                    <v-btn  @click="seeActivityLogs(item)" icon x-small color="blue" v-on="on">
                        <v-icon >far fa-eye</v-icon>
                    </v-btn>
                </template>
                <span>See detail</span>
            </v-tooltip>
        </template>
      </v-data-table>
  </v-card>
</template>

<script>
import {showMessageError,showMessageSuccess,showMessageWarning} from '../../services/sweetAlert'

  export default {
    data () {
      return {
        search: '',
        waiting:false,
        expanded: [],
        singleExpand: false,
        headers: [
          { text: 'Lumper Name', align: 'start', sortable: false, value: 'workerName',align: 'center' },
          { text: 'Total Services', value: 'totalServices',align: 'center' },
          { text: 'Total Hours worked', value: 'totalHourWorked',align: 'center' },
          { text: 'Total Hours paid', value: 'totalHourPaid' ,align: 'center'},
          { text: 'Total Paid', value: 'totalPaymed',align: 'center' },
          { text: 'Total Hours to pay', value: 'totalHourToPay',align: 'center' },
          { text: 'Total to pay', value: 'totalByPaymed',align: 'center' },
          { text: 'Actions', value: 'data-table-expand',align: 'center' },
        ],
        headersDetail: [
          { text: 'Service Id', align: 'start', sortable: false, value: 'idTravelWorker' ,align: 'center'},
          { text: 'Hour', value: 'hours' ,align: 'center'},
          { text: 'Rate', value: 'rate' ,align: 'center'},
          { text: 'Date', value: 'travel.date' ,align: 'center'},
          { text: 'Finish Date', value: 'dateStatus' ,align: 'center'},
          { text: 'Start Time', value: 'startTime',align: 'center' },
          { text: 'Is Paid?', value: 'paymed' ,align: 'center'},
          { text: 'Total paid', value: 'totalPaymed' ,align: 'center'},
          { text: 'Date paid', value: 'datePaymed' ,align: 'center'},
          { text: 'Actions', value: 'actions' ,align: 'center'},
        ],
        desserts: [],
        dateStart: '',//new Date().toISOString().substr(0, 10),
        dateEnd: '',//new Date().toISOString().substr(0, 10),
        menu1: false,
        modal: false,
        menu2: false,
        dialogCalendar:false
      }
    },
    methods:{
        async payWorker(item){
          var data = {IdTravelWorker:item.idTravelWorker}
          const response = await this.$store.dispatch('payWorker',data)
          if(response){
            if(response.status === 200){
              showMessageSuccess('Job marked as paid')
              this.getAll()
            }else{
              showMessageError('An error has ocurred')  
            }
          }else{
            showMessageError('An error has ocurred')
          }
        },
        getColor(status){
          const color = status === true ?   'green lighten-4':'red lighten-4'
          return color
        },
        resetFilter(){
            this.dateStart=''
            this.dateEnd=''
            this.desserts=[]
        },
        async getAll(){
            this.desserts=[]
            this.waiting = true
            var data = {startDate:this.dateStart, endDate:this.dateEnd}
            const response = await this.$store.dispatch('getReporteTotalHours',data)
            if(response.status === 200){
              this.waiting=false
                this.desserts = response.data
            }else{
                this.waiting =false
                showMessageError('An error occurred')
            }
        }
    }
  }
</script>